// imports
import * as $ from 'jquery';
import * as ButtonAreaState from './buttonAreaState';
import { Loader } from './loader';
import { NoteService } from '../services/noteService';

// globals
const service = new NoteService();
let filterTimeout;
let loadDataRequest;
let notes;

(window as any).unloadNotes = unloadNotes;

export function initialize(): void {
    $('.js-load-notes').on('click', onShowNotes);
    $('.js-delete-notes:first').on('click', handleDelete);
    $('.js-filter-notes:first').on('keyup', handleFilter);
};

export function getSelectedNotes(): any[] {
    const data = [];

    if (!notes) {
        return data;
    }

    const $checkboxes = $('.js-note-checkbox:checked');

    $checkboxes.each((index: number, checkbox: Node) => {
        const referenceId = (checkbox as HTMLInputElement).dataset.id;

        for (const document of notes) {
            for (const note of document.notes) {
                if (note.id === referenceId) {
                    data.push(note);
                    break;
                }
            }
        }
    });

    return data;
}

export function exportSelectedIds(): string[] {
    const ids: string[] = [];

    $('.js-note-checkbox:checked')
        .each((index: number, checkbox: Node) => {
            ids.push((checkbox as HTMLInputElement).dataset.id);
        });

    return ids;
}

function handleDelete(): void {
    const ids = exportSelectedIds();

    if (ids.length === 0) {
        alert('Inga anteckningar valda för att tas bort');
        return;
    }

    for (const id of ids) {
        service.deleteNoteById(id, () => {
            $(`li[data-id="${id}"]`).remove();
        }, () => {
            alert('Tillfälligt fel: Kan inte ta bort anteckning');
        });
    }
}

function handleFilter(): void {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
        if (loadDataRequest.abort) {
            loadDataRequest.abort();
        }
        loadData($(this).val() as string);
    }, 250);
}

function onShowNotes(event: any, params: any): void {
    $('.sidebar').addClass('sidebar--sub-level');
    $(".subNavigation").addClass("selected--notes");
    $(".pINotes").addClass("selectedItem");
    $("#mynotes_sidebar").addClass("selectedItem").focus();
    
    $(".pIFavorites").hide();
    $(".pIUser").hide();
    $(".pIRecentlyRead").hide();
    $(".pIWatched").hide();

    $("#mycoverage_sidebar").removeClass("selectedItem");
    $("#myfavorites_sidebar").removeClass("selectedItem");
    $("#mylatestvisited_sidebar").removeClass("selectedItem");

    loadData();

}

function unloadNotes(): void {
    notes = null;
}

function loadData(filter?: string): void {
    const $container = $('#sidebar-notes');
    const $noContentMsg = $container.find('.js-no-content-msg:first');
    const $loader = Loader.create();
    const $wrapper = $container.find('.notifications__notifications-list:first');

    if ($wrapper.length) {
        $wrapper.remove();
    }

    $noContentMsg.hide();
    $loader.insertAfter($noContentMsg);

    function success(data): void {
        notes = data;

        if (!data.length) {
            $loader.remove();
            $noContentMsg.show();
            return;
        }

        populateData(data, $container, $loader);
    }

    function error(): void {
        $loader.remove();
        $noContentMsg.show();
        alert('Tillfälligt fel: Kan inte hämta anteckningar');
    }

    if (filter) {
        loadDataRequest = service.getFilteredNotes(filter, success, error);
        return;
    }

    loadDataRequest = service.getNotes(success, error);
}

function populateData(data: any, $container: any, $loader: any): void {
    const $wrapper = generateWrapper();

    for (let item of data) {
        const $item = generateItem(item);
        const $childWrapper = $item.find('.notification-list:first');

        for (let childItem of item.notes) {
            if (!childItem) {
                continue;
            }
            const $childItem = generateChildItem(
                childItem.id,
                childItem.title,
                childItem.color,
                item.pageHeading,
                item.pageUrl,
                childItem.text,
                childItem.markupId,
                item.isArchived
            );
            $childWrapper.append($childItem);
        }

        $wrapper.append($item);
    }

    ButtonAreaState.toggleAriaState($wrapper);
    $loader.replaceWith($wrapper);
}

function generateWrapper(): any {
    return $(`<ol class="notifications__notifications-list"></ol>`);
}

function generateItem(item) {
    const { pageHeading, numberOfNotes, isArchived } = item;

    return $(`
        <li class="notifications__notifications-item">
            <a href="#" class="notifications__notifications-link  [ js-aria-state ]" aria-pressed="false">
                ${pageHeading}
                ${isArchived ? '<span class="notifications__archived">Upphävt</span>' : '' }
                <span class="notifications__amount-indicator">${numberOfNotes}</span>
            </a>
            <ol class="notification-list"></ol>
        </li>
    `);
}

function generateChildItem(id: string, title: string, color: string, pageHeading: string, pageUrl: string, note: string, markupId: string, isArchived: boolean): any {
    return $(`
        <li data-id="${id}" class="notification">
            <a href="#" class="notification__header note-color note-color--${color} [ js-aria-state ]" aria-pressed="false">
                ${title != null ? title : note != null ? note : 'Markering' }
            </a>
            <label class="notifications__select-item">
                <input data-id="${id}" type="checkbox" class="notifications__select-checkbox [ js-note-checkbox ]" />
                <span>Välj denna</span>
            </label>
            <div class="notification__meta">
                ${isArchived ? 'Dokumentet är inte längre tillgängligt' : `<a href="${pageUrl}#${markupId || ''}" class="notification__link">${pageHeading}</a>`}
            </div>
            <div class="notification__content">${note != null ? note : '<i>Enbart markering</i>'}</div>
        </li>
    `);
}